import { connect } from "react-redux";

import ProfileView from "./ProfileView";
import SavedSearchState from "../shipment-search/SavedSearchState";
import DomainDataState from "../domain-data/DomainDataState";
import { getLocations } from "../locations/LocationsState";
import ProfileState from "./ProfileState";

function mapStateToProps(state) {
  return {
    ...state.profile,
    auth: state.users.auth,
    carriers: DomainDataState.selectors.getCarriers(state),
    exceptionTypes: DomainDataState.selectors.getExceptionTypes(state),
    locations: getLocations(state),
    shipmentModes: DomainDataState.selectors.getShipmentModes(state),
    savedSearches: SavedSearchState.selectors.getSavedSearches(state),
    statusTypes: DomainDataState.selectors.getStatusTypes(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changePassword: (payload, userId) =>
      dispatch(ProfileState.actionCreators.changePassword(payload, userId)),
    fetchSavedSearches: () =>
      dispatch(SavedSearchState.actionCreators.fetchSavedSearches()),
    resetPasswordForm: () =>
      dispatch(ProfileState.actionCreators.resetPasswordForm()),
    selectSavedSearch: item =>
      dispatch(ProfileState.actionCreators.selectSavedSearch(item))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileView);



// WEBPACK FOOTER //
// ./src/modules/profile/ProfileContainer.js